import React from "react";

function PicIcon() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V3.25C19.25 2.14543 18.3546 1.25 17.25 1.25H3.25C2.14543 1.25 1.25 2.14543 1.25 3.25V17.25C1.25 18.3546 2.14543 19.25 3.25 19.25ZM3.25 19.25L14.25 8.25L19.25 13.25M8.25 6.75C8.25 7.57843 7.57843 8.25 6.75 8.25C5.92157 8.25 5.25 7.57843 5.25 6.75C5.25 5.92157 5.92157 5.25 6.75 5.25C7.57843 5.25 8.25 5.92157 8.25 6.75Z"
        stroke="#667085"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PicIcon;
